// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconSquare = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M52.4374 13.9124C52.1692 12.5835 51.4164 11.8308 50.0876 11.5626C46.8297 10.905 40.9879 10 32 10C23.0121 10 16.8284 10.9741 13.9124 11.5626C12.5836 11.8308 11.8309 12.5836 11.5626 13.9124C10.905 17.1703 10 23.0121 10 32C10 40.9879 10.9741 47.1716 11.5626 50.0876C11.8308 51.4164 12.5836 52.1691 13.9124 52.4374C17.1703 53.0949 23.0121 54 32 54C40.9879 54 47.1716 53.0259 50.0876 52.4374C51.4164 52.1691 52.1692 51.4164 52.4374 50.0876C53.0259 47.1716 54 40.9879 54 32C54 23.0121 53.095 17.1703 52.4374 13.9124Z" />
    </svg>
  );
};
